import { safetyMargins, HD, FULL_HD } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { middle, SCREEN_WIDTH, SCREEN_HEIGHT } from '../../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const METADATA_Y = {
  [HD]: 566,
  [FULL_HD]: 880,
};

export const PROGRESS_HEIGHT = {
  [HD]: 30,
  [FULL_HD]: 36,
};

export const PROGRESS_MARGIN_TOP = {
  [HD]: 16,
  [FULL_HD]: 16,
};

export const colors = {
  text: makeThemeColor(PRIMARY),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;
  const margin = {
    x: safetyMargins.horizontal[screenSize],
    y: safetyMargins.vertical[screenSize],
  };

  return {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    Main: {
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
      alpha: 0,
      transitions: {
        alpha: {
          duration: 0.3,
        },
      },
      TopBar: {
        ...margin,
      },
      Toggle: {
        mount: 0.5,
        x: middle,
        y: middle,
      },
      Metadata: {
        x: margin.x,
        y: METADATA_Y[screenSize],
      },
      SideGlass: {
        zIndex: 2,
      },
      Tracks: {
        zIndex: 2,
      },
      ProgramInformation: {
        zIndex: 2,
      },
      Progress: {
        mountY: 1,
        x: margin.x,
        y: SCREEN_HEIGHT[screenSize] - margin.y,
        w: SCREEN_WIDTH[screenSize] - margin.x * 2,
      },
    },
    AuxiliaryButtons: {
      mount: 1,
      x: SCREEN_WIDTH[screenSize] - margin.x,
      y: SCREEN_HEIGHT[screenSize] - margin.y - PROGRESS_HEIGHT[screenSize] - PROGRESS_MARGIN_TOP[screenSize],
    },
  };
};
